module.exports = __webpack_public_path__ + "static/channels-4-5686e8cdfd2210eb7006caa4bf438c73.svg";